import { Component, OnInit } from '@angular/core';
import { BuyerAccountUploadSuccessModalComponent } from './buyer-account-upload-success-modal.component';

@Component({
    selector: 'buyer-account-invoice-upload-success-modal',
    templateUrl: './buyer-account-upload-success-modal.component.html',
    styleUrls: ['./buyer-account-upload-success-modal.component.scss']
})
export class BuyerAccountInvoiceUploadSuccessModalComponent
    extends BuyerAccountUploadSuccessModalComponent
    implements OnInit {
    public subtitle = this._i18n({
        value: `Thanks for sending us your new invoice data.  Please allow a few minutes for your invoice information to be accessible within our system.`
    });
}
